// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdwBnlAA5tSiCaCYtVuRGW4CTsUhAfmSE",
  authDomain: "chandlerandannawedding.firebaseapp.com",
  projectId: "chandlerandannawedding",
  storageBucket: "chandlerandannawedding.firebasestorage.app",
  messagingSenderId: "99480708104",
  appId: "1:99480708104:web:a975c6a88dc21d74595dbd",
  measurementId: "G-YVYYQLT7CV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth(app);

export const db = getFirestore(app);
